import { useForm } from 'react-hook-form'
import { useMethods } from '@shared/hooks/methods'
import {
    useMutation,
    useQueryClient
} from '@tanstack/react-query'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import axios from '@shared/utils/axios'
import mapServerErrors from '@shared/utils/mapErrors'

const schema = yup.object({
    email: yup.string().required(),
    password: yup.string().required()
})

export const useLoginForm = () => {
    const queryClient = useQueryClient()
    const form = useForm({
        resolver: yupResolver(schema),
        defaultValues: {}
    })
    const { showMessage } = useMethods()
    const { mutate } = useMutation({
        mutationFn: async (variables) => {
            const request = await axios.post('auth/login', variables)
            return request.data
        },
        onMutate: () => {
            showMessage({
                text: 'جارٍ الدخول...',
                loading: true
            })
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['user'] })
            showMessage(null)
        },
        onError: (e) => {
            showMessage(null)
            mapServerErrors(e, form.setError, showMessage, form.getValues)
        }
    })

    return {
        form,
        mutate
    }
}